import { api } from '@/lib/api/axios';
import { City } from '@/types/domain/city';
import { State } from '@/types/domain/state';

export const GeographyService = {
  listStates: async () => {
    const response = await api.get<State[]>('/geography/states');

    return response;
  },
  listCities: async (params: { stateId: string; search?: string }) => {
    const response = await api.get<City[]>('/geography/cities', { params });

    return response;
  },
  listCitiesWithCompanies: async () => {
    const response = await api.get<City[]>('/geography/cities-with-companies');

    return response.data;
  },
};
